import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "15",
  height: "15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m2.1 7.2 3.8 3.7 7.6-7.5",
      class: "st0",
      style: {"fill":"none","stroke":"#464a7a","stroke-width":"2","stroke-miterlimit":"10"}
    }, null, -1)
  ]))]))
}
export default { render: render }